export type PresignedFormParams = {
  /**
   * Campos assinados do presigned POST, exatamente como o backend (`POST /files/`)
   * os devolve em `storage.fields`. Com SigV4 isso inclui `x-amz-algorithm`,
   * `x-amz-credential`, `x-amz-date` e `x-amz-signature` — todos exigidos pela
   * policy do S3. Espalhar este objeto inteiro evita cravar nomes de campo
   * (o bug que mandava `AWSAccessKeyId`/`signature` do SigV2 e omitia os
   * `x-amz-*`, fazendo o S3 rejeitar o upload com 403).
   */
  fields?: Record<string, string>;
  // Campos legados (back-compat para callers ainda não migrados).
  acl?: string;
  content_type?: string;
  key?: string;
  AWSAccessKeyId?: string;
  policy?: string;
  signature?: string;
};

/**
 * Monta o FormData do presigned POST do S3.
 *
 * Regras do S3 POST: todos os campos assinados primeiro, e o campo `file`
 * SEMPRE por último.
 */
export const buildPresignedForm = (
  file: Blob | File,
  params: PresignedFormParams,
): FormData => {
  const data = new FormData();

  if (params.fields) {
    Object.entries(params.fields).forEach(([key, value]) => {
      data.append(key, String(value));
    });
  } else {
    // Fallback legado: replica os campos antigos. Mantido só para não quebrar
    // callers que ainda não passam `fields`.
    if (params.acl !== undefined) data.append('acl', params.acl);
    if (params.content_type !== undefined) data.append('Content-Type', params.content_type);
    if (params.key !== undefined) data.append('key', params.key);
    if (params.AWSAccessKeyId !== undefined) data.append('AWSAccessKeyId', params.AWSAccessKeyId);
    if (params.policy !== undefined) data.append('policy', params.policy);
    if (params.signature !== undefined) data.append('signature', params.signature);
  }

  data.append('file', file);

  return data;
};
